import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { CatalogAdsActions } from '../constants/catalog_ads/catalog_ads_actions';
import ProductModel from './models/product';

class CatalogAdsStoreClass extends ReduceStore {
    getInitialState() {
        return {
            loadingAds: false,
            ads: [],
            buyerAssistUrl: null
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CATALOG_ADS_ACTION) {
            switch (action.type) {
                case CatalogAdsActions.SET_ADS:
                    state.loadingAds = false;
                    state.ads = action.payload.map((product) => {
                        return new ProductModel(product);
                    });

                    this.__emitChange();
                    break;

                case CatalogAdsActions.LOAD_CATALOG_ADS_ACTION:
                    state.loadingAds = true;
                    this.__emitChange();
                    break;

                case CatalogAdsActions.SET_BUYER_ASSIST_URL:
                    state.buyerAssistUrl = action.payload;
                    this.__emitChange();
                    break;


            }
        }

        return state;
    }
}

const CatalogAdsStore = new CatalogAdsStoreClass(Dispatcher);
export { CatalogAdsStore };